var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHideIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.842,
    height: 12.104,
    viewBox: "0 0 22.842 12.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_119",
    "data-name": "Rectangle 119",
    width: 22.842,
    height: 12.104,
    transform: "translate(0 0)",
    fill: "#919191"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide_icon_1",
    "data-name": "hide icon 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M11.421,0C5.113,0,0,6.754,0,6.754S5.113,12.1,11.421,12.1,22.842,6.754,22.842,6.754,17.729,0,11.421,0M16.2,6.052a4.784,4.784,0,1,1-4.784-4.785A4.79,4.79,0,0,1,16.2,6.052",
    transform: "translate(0 0)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M35.893,15.245a1.873,1.873,0,0,1-1.874-1.874,1.849,1.849,0,0,1,.237-.894l-.029,0a2.563,2.563,0,1,0,2.563,2.563c0-.01,0-.019,0-.029a1.848,1.848,0,0,1-.894.237",
    transform: "translate(-22.807 -8.985)",
    fill: "#919191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon1);
export default __webpack_public_path__ + "static/media/hide-icon-1.ee409430821bca461761d6ece382c100.svg";
export { ForwardRef as ReactComponent };